module.exports = __webpack_public_path__ + "img/senalando-izqca.png.5cdbbf23.webp";